import { Modal, ModalHeaderProps } from '@mantine/core';
import clsx from 'clsx';
import { forwardRef } from 'react';

export type ModalFormHeaderProps = ModalHeaderProps;

export const createModalFormHeader = () => {
	const ModalFormHeader = forwardRef<HTMLElement, ModalFormHeaderProps>(
		({ className, children, ...props }, ref) => (
			<Modal.Header
				ref={ref}
				className={clsx('modal-form-header', className)}
				{...props}
			>
				{children}
			</Modal.Header>
		),
	);

	return ModalFormHeader;
};
